import InputField from "../../../components/InputField";
import OptionalFields from "../../../components/OptionalFields";
import Toggle from "../../../components/Toggle";

export default function ComodantStep({ data, errors, update }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
      <div style={{ width: "100%" }}>
        <Toggle
          label="Persoana juridica"
          description="Comodantul este o firma / societate comerciala"
          checked={!!data.comodantPJ}
          onChange={() => update("comodantPJ")(!data.comodantPJ)}
        />
      </div>

      {data.comodantPJ ? (
        <>
          <InputField label="Denumire societate" value={data.comodantFirma} onChange={update("comodantFirma")} placeholder="ex: SC Exemplu SRL" required error={errors.comodantFirma} />
          <InputField label="CUI" value={data.comodantCUI} onChange={update("comodantCUI")} placeholder="ex: RO12345678" required half error={errors.comodantCUI} />
          <InputField label="Nr. Reg. Comertului" value={data.comodantRegCom} onChange={update("comodantRegCom")} placeholder="ex: J40/1234/2020" half error={errors.comodantRegCom} />
          <InputField label="Sediu social" value={data.comodantSediu} onChange={update("comodantSediu")} placeholder="ex: Str. Exemplu nr. 1, Bucuresti" required error={errors.comodantSediu} />
          <InputField label="Reprezentant legal" value={data.comodantReprezentant} onChange={update("comodantReprezentant")} placeholder="ex: Popescu Ion" required error={errors.comodantReprezentant} />
        </>
      ) : (
        <>
          <InputField label="Nume complet" value={data.comodantNume} onChange={update("comodantNume")} placeholder="ex: Popescu Ion" required error={errors.comodantNume} />
          <InputField label="Adresa de domiciliu" value={data.comodantAdresa} onChange={update("comodantAdresa")} placeholder="ex: Str. Exemplu nr. 1, Bucuresti" required error={errors.comodantAdresa} />
          <OptionalFields>
            <InputField label="CNP" value={data.comodantCNP} onChange={update("comodantCNP")} placeholder="ex: 1234567890123" half error={errors.comodantCNP} helperText="Opțional — poți completa de mână pe document" />
            <InputField label="Serie si nr. CI" value={data.comodantCI} onChange={update("comodantCI")} placeholder="ex: RD 123456" half error={errors.comodantCI} helperText="Opțional — poți completa de mână pe document" />
          </OptionalFields>
        </>
      )}
    </div>
  );
}
